<template>
    <div>
        <accordion-setting
            id="settingsTitle"
            title="Configurações Titulo"
            :visible="visible"
        >
            <!-- CONFIGURAÇÃO DE LARGURA -->
            <div class="py-2">
                <setting-frame-width
                    :item="item"
                    @onChangeWidth="onChangeWidth"
                />
            </div>

            <!-- CONFIGURAÇÃO DE MARGIN -->
            <div class="py-2">
                <setting-frame-margin
                    :item="item"
                    @onChangeMargin="onChangeMargin"
                    @onChangeMarginMobile="onChangeMarginMobile"
                    @onChangeLockMarginMobile="onChangeLockMarginMobile"
                />
            </div>
            
            <!-- CONFIGURAÇÃO DE PADDING -->
            <div class="py-2">
                <setting-frame-padding
                    :item="item"
                    @onChangePadding="onChangePadding"
                    @onChangePaddingMobile="onChangePaddingMobile"
                    @onChangeLockPaddingMobile="onChangeLockPaddingMobile"
                />
            </div>

            <!-- CONFIGURAÇÃO DE TAMANHO DA FONTE -->
            <div class="py-2">
                <setting-frame-style-font-size
                    :item="item"
                    @onChangeStyleFontSize="onChangeStyleFontSize"
                    @onChangeStyleFontSizeLock="onChangeStyleFontSizeLock"
                />
            </div>
            
            <!-- CONFIGURAÇÃO DE ESPESSURA DA FONTE -->
            <div class="py-2">
                <setting-frame-style-font-weight
                    :item="item"
                    @onChangeStyleFontWeight="onChangeStyleFontWeight"
                    @onChangeStyleFontWeightLock="onChangeStyleFontWeightLock"
                />
            </div>

            <!-- CONFIGURAÇÃO DE ALINHAMENTO DO TEXTO -->
            <div class="py-2">
                <setting-frame-style-text-align
                    :item="item"
                    @onChangeStyleTextAlignLock="onChangeStyleTextAlignLock"
                    @onChangeStyleTextAlign="onChangeStyleTextAlign"
                />
            </div>

            <!-- CONFIGURAÇÃO DE COR DO TEXTO -->
            <div class="py-2">
                <setting-frame-style-color
                    :item="item"
                    @onChangeStyleColor="onChangeStyleColor"
                />
            </div>
            <!--
            <div class="mt-3 d-flex justify-content-end">
                <button class="btn btn-primario py-2" @click="handleSaveFrameConfig">
                    Salvar
                </button>
            </div>
            -->
        </accordion-setting>
    </div>
</template>

<script>
import SettingFrameWidth from "../atoms/SettingFrameWidth.vue";
import AccordionSetting from '../atoms/AccordionSetting.vue';
import SettingFrameStyleFontSize from '../atoms/SettingFrameStyleFontSize.vue';
import SettingFrameStyleFontWeight from '../atoms/SettingFrameStyleFontWeight.vue';
import SettingFrameMargin from '../atoms/SettingFrameMargin.vue';
import SettingFramePadding from '../atoms/SettingFramePadding.vue';
import SettingFrameStyleTextAlign from '../atoms/SettingFrameStyleTextAlign.vue';
import SettingFrameStyleColor from '../atoms/SettingFrameStyleColor.vue';

export default {
    name: "SettingsFrameTitle",
    components: {
        SettingFrameWidth,
        AccordionSetting,
        SettingFrameStyleFontSize,
        SettingFrameStyleFontWeight,
        SettingFrameMargin,
        SettingFramePadding,
        SettingFrameStyleTextAlign,
        SettingFrameStyleColor,
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        visible: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
        }
    },  
    methods: {
        handleSaveFrameConfig() {
            this.$emit("saveItemChanges", this.item);
        },
        onChangeWidth(item) {
            this.item.grid = item.grid;
            this.item.gridMobile = item.gridMobile;
                            
            this.handleSaveFrameConfig();
        },
        onChangePadding(value) {
            this.item.extra.padding = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangePaddingMobile(value) {
            this.item.extra.padding_mobile = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeLockPaddingMobile(value) {
            this.item.extra.padding_mobile_lock = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeMargin(value) {
            this.item.extra.margin = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeMarginMobile(value) {
            this.item.extra.margin_mobile = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeLockMarginMobile(value) {
            this.item.extra.margin_mobile_lock = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeStyleFontSize(fontSize) {
            this.item.extra.style.fontSize = fontSize;

            this.handleSaveFrameConfig();
        },
        onChangeStyleFontSizeLock(isLock) {
            this.item.extra.style_font_size_lock = isLock;

            this.handleSaveFrameConfig();
        },
        onChangeStyleFontWeight(fontWeight) {
            this.item.extra.style.fontWeight = fontWeight;

            this.handleSaveFrameConfig();
        },
        onChangeStyleFontWeightLock(isLock) {
            this.item.extra.style_font_weight_lock = isLock;

            this.handleSaveFrameConfig();
        },
        onChangeStyleTextAlignLock(isLock) {
            this.item.extra.style_text_align_lock = isLock;

            this.handleSaveFrameConfig();
        },
        onChangeStyleTextAlign(align) {
            this.item.extra.style.textAlign = align;

            this.handleSaveFrameConfig();
        },
        onChangeStyleColor(color) {
            this.item.extra.style.color = color;

            this.handleSaveFrameConfig();
        },
    },
    created() {
        if (!this.item.extra) {
            this.item.extra = {};
        }

        if (typeof this.item.extra.style === 'undefined' || this.item.extra.style === null) {
            this.item.extra.style = {
                fontSize: '',
                fontWeight: '',
                textAlign: '',
                color: '',
            };
        }

        if (typeof this.item.extra.style.fontSize === 'undefined' || this.item.extra.style.fontSize === null || this.item.extra.style.fontSize === '') {
            this.item.extra.style.fontSize = '16px';
        }

        if (typeof this.item.extra.style_font_size_lock === 'undefined' || this.item.extra.style_font_size_lock === null) {
            this.item.extra.style_font_size_lock = true;
        }

        if (typeof this.item.extra.style.fontWeight === 'undefined' || this.item.extra.style.fontWeight === null || this.item.extra.style.fontWeight === '') {
            this.item.extra.style.fontWeight = 700;
        }

        if (typeof this.item.extra.style_font_weight_lock === 'undefined' || this.item.extra.style_font_weight_lock === null) {
            this.item.extra.style_font_weight_lock = true;
        }

        if (typeof this.item.extra.style_text_align_lock === 'undefined' || this.item.extra.style_text_align_lock === null) {
            this.item.extra.style_text_align_lock = true;
        }

        if (typeof this.item.extra.style.textAlign === 'undefined' || this.item.extra.style.textAlign === null || this.item.extra.style.textAlign === '') {
            this.item.extra.style.textAlign = 'left';
        }

        if (typeof this.item.extra.style.color === 'undefined' || this.item.extra.style.color === null) {
            this.item.extra.style.color = '';
        }
    },
};
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/molecules/SettingsFrameTitle.vue